import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.value
    await navigator.clipboard.writeText(text)

    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = "コピーしました"
    setTimeout(() => {
      this.buttonTarget.textContent = original
    }, 2000)
  }
}
